/**
 * Module definition houses all application media
 *
 * @module components.media
 */
angular.module('components.media', [
  'components.media.image',
  'components.media.file',
  'components.media.audio',
  'components.media.video'
]);
